import { useEffect } from "react";
import PropTypes from "prop-types";
import ConsentProcessing from "../Configuration/ConsentProcessing";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import useTracker from "../../hooks/useTracker";
import ConfigCard from "./ConfigCard";
import Coco from "./Coco/Coco";
import RemoteConfig from "./RemoteConfig";

const Configuration = ({
  activeTab,
  setActiveTab,
  configdetails,
  configtabledetails,
  loading,
}) => {
  const { activeTabTracker } = useTracker();
  const activeTabs = useSelector((state) => state.TrackerReducer.active_tab);
  useEffect(() => {
    if (activeTabs == "") {
      setActiveTab(1);
    } else setActiveTab(activeTabs);
  }, []);
  return (
    <div className="" id="configData">
      <ConfigCard configDetails={configdetails} loading={loading} />
      <div>
        <div className="d-flex justify-content-start align-items-end gap-2">
          <button
            type="button"
            className={
              activeTab === 1
                ? `tabs-btn tabs-active`
                : `tabs-btn`
            }
            onClick={() => {
              setActiveTab(1);
              activeTabTracker({
                active_tab: 1,
              });
            }}
          >
            <FormattedMessage
              id="label.consent-processing"
              defaultMessage="Consent Processing"
            />
          </button>
          <button
            type="button"
            className={
              activeTab === 2
                ? `tabs-btn tabs-active`
                : `tabs-btn`
            }
            onClick={() => {
              setActiveTab(2);
              activeTabTracker({
                active_tab: 2,
              });
            }}
          >
            <FormattedMessage
              id="label.legitimate-interest"
              defaultMessage="Legitimate Interest"
            />
          </button>
          <button
            type="button"
            className={
              activeTab === 3
                ? `tabs-btn tabs-active`
                : `tabs-btn`
            }
            onClick={() => {
              setActiveTab(3);
              activeTabTracker({
                active_tab: 3,
              });
            }}
          >
            <FormattedMessage id="navbar.coco" defaultMessage="Coco" />
          </button>
          <button
            type="button"
            className={
              activeTab === 4
                ? `tabs-btn tabs-active`
                : `tabs-btn`
            }
            onClick={() => {
              setActiveTab(4);
              activeTabTracker({
                active_tab: 4,
              });
            }}
          >
            <FormattedMessage id="navbar.remote-config" defaultMessage="Remote Config" />
          </button>
        </div>
        {activeTab === 1 && (
          <ConsentProcessing
            details={
              !loading &&
              configtabledetails?.data?.filter(
                (allData) => allData.legal_basis === "consent"
              )
            }
            loading={loading}
          />
        )}
        {activeTab === 2 && (
          <ConsentProcessing
            details={
              !loading &&
              configtabledetails?.data?.filter(
                (allData) => allData.legal_basis === "legitimate_interest"
              )
            }
            loading={loading}
          />
        )}
        {activeTab === 3 && <Coco loading={loading} />}
        {activeTab === 4 && <RemoteConfig ConfigInfoData={configtabledetails?.data?.find(item => item.legal_basis === "consent")} />}
      </div>
    </div>
  );
};

Configuration.propTypes = {
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  configdetails: PropTypes.object,
  configtabledetails: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        legal_basis: PropTypes.string,
      })
    ),
  }),
  loading: PropTypes.bool,
};

export default Configuration;
